import { NumberParam, StringParam } from "use-query-params";
import { ListModel } from "../models/list-model";

// search params config
export const queryParamsConfig = {
  page: NumberParam,
  pageSize: NumberParam,
  search: StringParam,
  obraSocialId: StringParam,
  sortDirection: NumberParam,
  sortColumn: StringParam,
};

export const initialFilter = {
  page: 1,
  pageSize: 15,
};
